export const serverUrl = "https://mapapimssql.datastems.com";
//export const serverUrl = "http://localhost:5000";

// export const serverUrl = "http://sever1:8080";
// export const serverUrl = "http://sever2:8080";
// export const serverUrl = "http://sever3:8080";
